import { useState, useEffect } from "react";
import { useWindowDimensions } from "../../hooks/useDimensions";
import { motion, useScroll, useMotionValueEvent, useAnimation, useIn } from "framer-motion";

function Hero() {
  const { scrollY } = useScroll();
  const dimens = useWindowDimensions();
  const [scrolled, setScrolled] = useState(false);
 
  const container = {
    scrolled: { opacity: 0.1, y: -8 },
    fresh: { opacity: 1 },
  };

  const subheader = {
    scrolled: { opacity: 0.3, y: "-60%" },
    fresh: { opacity: 0.2 },
  };

  useMotionValueEvent(scrollY, "change", (scrollY) => {
    setScrolled(scrollY > 120);
  });

  let scaleVal = dimens.width < 568 ? dimens.width / 568 : 1;
  let stringTest = "scaleX(" + scaleVal + ")";

  useEffect(() => {
    scaleVal = dimens.width < 568 ? dimens.width / 568 : 1;
    stringTest = "scaleX(" + scaleVal + ")";
  });

  return (
    <div className=" mt-[70px] mb-[200px] desktop:mx-7">
      {/* <div>scrollPoint: {scrollY.current}</div> */}
      <header className="font-murmure fixed top-[70px] tablet:top-[90px] desktop:top-[120px] left-0 right-0 pointer-events-none">
        <motion.div
          className={`flex flex-col justify-center items-center`}
          //   style={{}}
          variants={container}
          initial="hidden"
          animate={scrolled ? "scrolled" : "fresh"}
        >
          <h1
            className="sm:text-[26.5vw] text-[9rem] leading-none"
            style={{ transform: stringTest }}
          >
            TOUCHPOINT’23
          </h1>
          <motion.h2
            className="text-[14.3vw] leading-none mt-[-3vw]"
            variants={subheader}
            initial="hidden"
            animate={scrolled ? "scrolled" : "fresh"}
          >
            annual design conference
          </motion.h2>
        </motion.div>
      </header>

      {/* <div className="h-[350px] tablet:h-[450px] desktop:h-[680px]"></div> */}
      {/* <div className="inline-block h-0 pb-[80%] tablet:pb-[50%] desktop:pb-[55%] w-[80%]"></div> */}
      <section className="font-apfelgrotezk mb-[40px] mx-3 tablet:mx-4 desktop:mx-0 text-[1rem] desktop:text-[35px] mt-[calc(100vh-12rem)] tablet:mt-[calc(100vh-14rem)]">
        <a
          href="https://goo.gl/maps/rUvxwV1v1rtGGbDz8"
          target="_blank"
          className="block underline  w-[208px] desktop:w-[454px] desktop:decoration-1 leading-none"
        >
          SFU Surrey (SYRE Building) &rarr; 10285 University Dr, Surrey, BC
        </a>
        <p className="float-right mt-[20px]">**Saturday, March 18</p>
      </section>
    </div>
  );
}

export default Hero;
